import React from 'react';

import { FullPageBox } from '../../components/full-page-box/full-page-box';
import { RequestPasswordResetLinkForm } from '../../components/request-password-reset-link-form/request-password-reset-link-form';

type Props = {
  onGoToLoginPage: () => void;
};

const RequestPasswordResetLink = ({ onGoToLoginPage }: Props) => (
  <FullPageBox width="400px">
    <RequestPasswordResetLinkForm onGoToLoginPage={onGoToLoginPage} />
  </FullPageBox>
);

export { RequestPasswordResetLink };
